import {
  DropdownField,
  FieldTypes,
  getFullName,
  getPracticeUsersCollectionPath,
  objectToArray,
  practiceAdminRoles,
  PracticeUserRoleItem,
} from '@hb/shared'
import { collection, CollectionReference, query, where } from 'firebase/firestore'
import { useMemo } from 'react'
import { db } from '../../../backend/db/db'
import { useQuery } from '../../../hooks/backend/useQuery'

export const usePracticeProviders = (practiceId: string | null) => {
  const providersQuery = useMemo(() => {
    if (!practiceId) return null
    return query(
      collection(
        db,
        getPracticeUsersCollectionPath(practiceId),
      ) as CollectionReference<PracticeUserRoleItem>,
      where('role', 'in', practiceAdminRoles),
    )
  }, [practiceId])

  return useQuery(providersQuery)
}

export const usePracticeProviderField = (
  practiceId: string | null,
  placeholder = 'Provider',
  excludeIds?: string[],
): DropdownField => {
  const { data } = usePracticeProviders(practiceId)
  return useMemo<DropdownField>(
    () => ({
      type: FieldTypes.DROPDOWN,
      searchable: true,
      options: objectToArray(data ?? {})
        .filter(i => !excludeIds?.includes(i.id))
        .map(i => ({ id: i.id, text: getFullName(i) })),
      placeholder,
    }),
    [data, placeholder, excludeIds],
  )
}

export const usePracticeProvidersField = (
  practiceId: string | null,
  placeholder = 'Provider',
  excludeIds?: string[],
): DropdownField => {
  const { data } = usePracticeProviders(practiceId)

  return useMemo<DropdownField>(
    () => ({
      type: FieldTypes.DROPDOWN,
      searchable: true,
      options: objectToArray(data ?? {})
        .filter(i => !excludeIds?.includes(i.id))
        .map(i => ({ id: i.id, text: getFullName(i) })),
      allowMultiple: true,
      placeholder,
    }),
    [data, placeholder, excludeIds],
  )
}
